import { render, staticRenderFns } from "./BottonXq.vue?vue&type=template&id=31bae589&scoped=true"
import script from "./BottonXq.vue?vue&type=script&lang=js"
export * from "./BottonXq.vue?vue&type=script&lang=js"
import style0 from "./BottonXq.vue?vue&type=style&index=0&id=31bae589&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bae589",
  null
  
)

export default component.exports